import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import vi from "./locales/vi.json";

void i18n.use(initReactI18next).init({
  resources: {
    vi: { translation: vi },
    en: { translation: en },
  },
  lng: import.meta.env.VITE_APP_LOCALE ?? "vi",
  fallbackLng: "vi",
  interpolation: {
    escapeValue: false, // React đã escape sẵn
  },
});

export default i18n;
